module.exports = __webpack_public_path__ + "img/showbill1.6c33cebf.jpg";